import { render, staticRenderFns } from "./SensorTypeDrawer.vue?vue&type=template&id=1bb8c10d&scoped=true"
import script from "./SensorTypeDrawer.vue?vue&type=script&lang=js"
export * from "./SensorTypeDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8c10d",
  null
  
)

export default component.exports